import { writable, get } from "svelte/store";
import { geolocErrorShownStore, geolocStore } from "./geolocStore";
import { getGeoloc } from "../utils/getGeoloc";
import { addToast } from "./toastStore";
import { translation } from "../stores";
import { numberOfReceivedImages, linkToImage } from '../scripts/stores.js';
import { pointerStore } from "./pointerStore";
import { handleAnswer, handleOffer } from "./peerConnectionStore";
import { pauseLocalVideoStreamFromRemote, resumeLocalVideoStreamFromRemote } from "./localVideoStore";
import { turnOffLocalTorchFromRemote, turnOnLocalTorchFromRemote } from "./torchStore";
export const dataChannelStore = writable({});
export let sendChannel = null;
export let sendFileChannel = null;
export let receiveChannel = null;
export function createDataChannel(pc, label) {
    console.log('[createDataChannel] channel: ', label);
    const channel = pc.createDataChannel(label);
    channel.onopen = () => console.log(`[dataChannel] "${label}" opened`);
    channel.onclose = () => console.log(`[dataChannel] "${label}" closed`);
    channel.onmessage = () => console.log(`[dataChannel] "${label}" onmessage`);
    if (label === "sendFromMoss")
        sendChannel = channel;
    dataChannelStore.update(channels => (Object.assign(Object.assign({}, channels), { [label]: channel })));
    return channel;
}
export function setupIncomingDataChannel(pc) {
    pc.ondatachannel = (event) => {
        const channel = event.channel;
        console.log("[dataChannel] incoming channel received:", channel.label);
        channel.onopen = () => console.log(`[dataChannel] "${channel.label}" opened`);
        channel.onclose = () => console.log(`[dataChannel] "${channel.label}" closed`);
        channel.onerror = (err) => console.error(`[dataChannel] error:`, err);
        if (channel.label === "sendFromMoss") {
            receiveChannel = channel;
            channel.onmessage = (event) => handleSendFromMossMessage(event.data);
        }
        else if (channel.label === "sendFile") {
            sendFileChannel = channel;
            sendFileChannel.imgReceivedBuffer = [];
            channel.binaryType = "arraybuffer";
            channel.onmessage = (event) => handleSendFileMessage(event.data, channel);
        }
        else {
            console.warn("[dataChannel] unknown channel label:", channel.label);
        }
        dataChannelStore.update(channels => (Object.assign(Object.assign({}, channels), { [channel.label]: channel })));
    };
}
async function handleSendFromMossMessage(msg) {
    try {
        const data = JSON.parse(msg);
        console.log('[dataChannelStore][handleSendFromMossMessage] data received:', data);
        switch (data.type) {
            case 'video':
                switch (data.type) {
                    case 'video':
                        if (data.action === 'pause') {
                            pauseLocalVideoStreamFromRemote();
                        }
                        if (data.action === 'resume') {
                            resumeLocalVideoStreamFromRemote();
                        }
                        if (data.action === 'torchOn') {
                            turnOnLocalTorchFromRemote();
                        }
                        if (data.action === 'torchOff') {
                            turnOffLocalTorchFromRemote();
                        }
                        break;
                }
                break;
            case 'geoloc':
                if (data.action === 'request') {
                    geolocStore.set({ status: 'sending' });
                    try {
                        const pos = await getGeoloc();
                        geolocStore.set({ status: 'success', latitude: pos.latitude, longitude: pos.longitude });
                        sendChannel.send(JSON.stringify({
                            type: 'geoloc',
                            action: 'send',
                            Latitude: pos.latitude,
                            Longitude: pos.longitude
                        }));
                    }
                    catch (err) {
                        const msg = translation.alert.activePosition;
                        geolocStore.set({ status: 'error', msg });
                        if (!get(geolocErrorShownStore)) {
                            geolocErrorShownStore.set(true);
                        }
                        sendChannel.send(JSON.stringify({ type: 'geoloc', action: 'error', msg }));
                        console.error('Position denied:', err);
                    }
                }
                break;
            case 'connection':
                if (data.action === 'ICEOffer')
                    await handleOffer(data.sdp);
                else if (data.action === 'ICEAnswer')
                    await handleAnswer(data.sdp);
                break;
            case 'pointer':
                pointerStore.set(data.data);
                break;
            default:
                console.warn("[dataChannel] data.type unknown:", data.type);
        }
    }
    catch (err) {
        console.error("[sendFromMoss] failed to parse message:", err, msg);
    }
}
function handleSendFileMessage(data, channel) {
    var _a;
    if (!channel.imgReceivedBuffer)
        channel.imgReceivedBuffer = [];
    try {
        if (data !== 'EOF') {
            channel.imgReceivedBuffer.push(new Uint8Array(data));
        }
        else {
            const arrayBuffer = channel.imgReceivedBuffer.reduce((acc, chunk) => {
                const tmp = new Uint8Array(acc.byteLength + chunk.byteLength);
                tmp.set(acc, 0);
                tmp.set(chunk, acc.byteLength);
                return tmp;
            }, new Uint8Array());
            const blob = new Blob([arrayBuffer]);
            numberOfReceivedImages.update(n => n + 1);
            const blobUrl = window.URL.createObjectURL(blob);
            const img = document.createElement("img");
            img.src = blobUrl;
            img.onclick = (event) => {
                linkToImage.set(event.target.getAttribute('src'));
            };
            (_a = document.querySelector('#side-panel')) === null || _a === void 0 ? void 0 : _a.appendChild(img);
            channel.imgReceivedBuffer = [];
            addToast('success', translation.camera.newImageNotification);
        }
    }
    catch (err) {
        console.error("Error while handling file message:", err);
    }
}
export function sendDataChannelMessage(label, msg) {
    const channels = get(dataChannelStore);
    const channel = channels[label];
    if (channel && channel.readyState === "open")
        channel.send(msg);
    else
        console.warn(`[dataChannel] cannot send, channel "${label}" not open`);
}
export function closeDataChannels() {
    var _a;
    const channels = get(dataChannelStore);
    for (const label in channels)
        (_a = channels[label]) === null || _a === void 0 ? void 0 : _a.close();
    dataChannelStore.set({});
    sendChannel = null;
    sendFileChannel = null;
    receiveChannel = null;
}
